module.exports = __webpack_public_path__ + "static/media/back-arrow-header.af929f77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/back-arrow-header.svg
// module id = 301
// module chunks = 0